import { ImmerBasedPatchTypes } from "@buildwithflux/models";
import { guid } from "@buildwithflux/shared";
function isPatch(change) {
    return "type" in change && change.type === ImmerBasedPatchTypes.patchSequence;
}
/**
 * Construct an action record.
 */
export function createActionRecord(args) {
    return {
        actionRecordUid: isPatch(args.changeData) ? args.changeData.uid : guid(),
        actionPreviousUid: isPatch(args.changeData) ? args.changeData.previousUid : null,
        actionName: args.name,
        actionUserUid: args.actingUserUid,
        actionUserHandle: args.actingUserHandle,
        actionTimestamp: args.timestamp,
        actionDocumentUid: args.changedDocumentUid,
        actionChangeDiff: args.changeData,
        actionUpdatesDocumentVersion: args.actionUpdatesDocumentVersion,
    };
}
//# sourceMappingURL=create.js.map